import { Observable, of } from 'rxjs';

import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Optional } from '@angular/core';

import { HttpCachingService } from '../service/http-caching.service';
import { Constants } from '../shared/constants';

@Injectable()
export class HttpCachingInterceptor implements HttpInterceptor {
  constructor(@Optional() private httpCachingService: HttpCachingService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.httpCachingService || !req.headers.has(Constants.cachingHeaderMaxAgeKey)) {
      return next.handle(req);
    }
    req = req.clone({ headers: req.headers.delete(Constants.cachingHeaderMaxAgeKey) });
    const cachedResponse = this.httpCachingService.get(req);
    return cachedResponse ? of(cachedResponse) : this.httpCachingService.set(req, next, +req.headers.get(Constants.cachingHeaderMaxAgeKey));
  }

}
